import { render, staticRenderFns } from "./PolicyEmbeddedTaskList.vue?vue&type=template&id=0d48a1ed&scoped=true"
import script from "./PolicyEmbeddedTaskList.vue?vue&type=script&lang=ts"
export * from "./PolicyEmbeddedTaskList.vue?vue&type=script&lang=ts"
import style0 from "./PolicyEmbeddedTaskList.vue?vue&type=style&index=0&id=0d48a1ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48a1ed",
  null
  
)

export default component.exports